module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAAJ1BMVEVHcEwFmv8Fmv8Fmv8Fmv8Fmv8Fmv8Fmv8Fmv8Fmv8Fmv8Fmv8Fmv/HopKBAAAADHRSTlMAgH+xz0r0yRQZMS222IoLAAAAUElEQVQI122OSw7AIAgFQaBqy/3P24rhY9K3myFxBPCNzg+UkeolhVE/cTu1ZoIdVU30QBM0EpeAioq/aO8mzh2Kq+wQwlHG+u0IrTGhzMQXhSwDLv8MQcsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/parts/catalog/card/components/block/images/pencil.png
// module id = 0af22b27654e1eed3d38
// module chunks = 0